module.exports = __webpack_public_path__ + "img/Body_feathers_Normal.33f1298.png";